import { OptionBase } from '@/shared/types/common';

export const INPUT_TYPES: OptionBase<{ type: 'input_type' }>[] = [
  { label: 'Text', value: 'text', type: 'input_type' },
  { label: 'Number', value: 'number', type: 'input_type' },
  { label: 'Integer', value: 'integer', type: 'input_type' },
  { label: 'Boolean', value: 'boolean', type: 'input_type' },
  { label: 'Url', value: 'url', type: 'input_type' },
  { label: 'Phone', value: 'phone', type: 'input_type' },
  { label: 'Email', value: 'email', type: 'input_type' },
  { label: 'File', value: 'file', type: 'input_type' },
  { label: 'Date', value: 'date', type: 'input_type' },
  { label: 'Time', value: 'time', type: 'input_type' },
  { label: 'Datetime', value: 'datetime', type: 'input_type' },
  { label: 'Currency', value: 'currency', type: 'input_type' },
  { label: 'Percentage', value: 'percentage', type: 'input_type' },
  { label: 'Any', value: '', type: 'input_type' },
];

export const isInputType = (val: string): boolean => {
  return INPUT_TYPES.some((inputType) => inputType.value === val);
};

export const getInputTypeLabel = (val: string): string => {
  return INPUT_TYPES.find((inputType) => inputType.value === val)?.label ?? val;
};
